import {get} from './capitalAxios';
import {buildQueryParams} from '../utils';

const BASE = '/api/v1/ledger/account';

export const getAccountBalance = (accountId, at) =>
    get(`${BASE}/${accountId}/balance` + buildQueryParams([{key: 'at', value: at}]));

export const getAccountTimeline = (accountId, from, to) =>
    get(`${BASE}/${accountId}/timeline` + buildQueryParams([
        {key: 'from', value: from},
        {key: 'to', value: to},
    ]));

export const getAccountsTimelines = (accountIds, from, to) => {
    const p = new URLSearchParams();
    if (from) p.append('from', from);
    if (to) p.append('to', to);
    accountIds.forEach(id => p.append('accountIds', id));
    return get(`/api/v1/ledger/accounts/timeline?${p.toString()}`);
};

export const getDashboardWorth = (monthStart) =>
    get('/api/v1/dashboard/worth' + buildQueryParams([{key: 'monthStart', value: monthStart}]));